import { api } from "./client";

export type ConversationDetail = {
  conversation_id: string;
  title: string;
  summary: string;
  use_case: string;
  quality: number;
  outcome: string;
  complexity: string;
  tool_usage: string;
  turn_count: number;
  strengths: string[];
  improvements: string[];
  is_personal: boolean;
  created_at: string;
};

export type ReportData = {
  user?: { id: number; email: string; name: string; department: string | null };
  department?: string;
  period: { start: string; end: string };
  summary?: {
    conversation_count: number;
    total_turns: number;
    avg_turns_per_conv: number;
    avg_prompt_quality: number;
  };
  use_case_breakdown?: { use_case: string; count: number; pct: number }[];
  quality_distribution?: Record<string, number>;
  outcomes?: Record<string, number>;
  personal_use?: { count: number; pct: number; policy_reminder_shown: boolean };
  top_topics?: string[];
  coaching_hints?: string[];
  top_improvements?: string[];
  strengths_summary?: string[];
  good_prompt_example?: { conversation_id: string; snippet: string; quality_score: number } | null;
  conversations?: ConversationDetail[];
  adoption?: { active_users: number; total_users: number; inactive_users: string[] };
  top_use_cases?: { use_case: string; count: number; pct: number }[];
  avg_prompt_quality?: number;
  total_conversations?: number;
  personal_use_summary?: {
    dept_personal_pct: number;
    users_over_threshold_25pct: { user_id: number; email: string; personal_pct: number; conv_count: number }[];
  };
};

export type ReportResponse = {
  id: number;
  period_start: string;
  period_end: string;
  generated_at: string;
  data: ReportData;
};

export type GenerateResponse = {
  status: string;
  period_start: string;
  period_end: string;
  data: ReportData;
};

export const reportsApi = {
  myLatest: () => api.get<ReportResponse>("/reports/my-latest"),
  userReport: (userId: number) => api.get<ReportResponse>(`/reports/user/${userId}`),
  departmentReport: (dept: string) => api.get<ReportResponse>(`/reports/department/${encodeURIComponent(dept)}`),
  generateMyWeekly: () => api.post<GenerateResponse>("/reports/generate-my-weekly"),
  generateForUser: (userId: number) => api.post<GenerateResponse>(`/reports/generate/${userId}`),
};
